// extracted by mini-css-extract-plugin
export var linkText = "_oi-0";